import { Component } from '@angular/core';
import { FeedService } from '../../Model/Feeds/feed.service';
import { EmployeeRegistrationService } from '../../Model/EmployeeRegistration/employee-registration.service';
import { SessionService } from '../../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { UtilityService } from '../../Model/utility/utility.service';

@Component({
  selector: 'app-feed',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './feed.component.html',
  styleUrl: './feed.component.scss'
})
export class FeedComponent {
  isDisabled: boolean = false;
  EmpMasterID!: number;
  fileName = '';
  fileUrl = '';
  user = [] as any;

  FeedDetails = {
    SelectType: "insert",
    ESS_PostMasterID: 0,
    CompanyId: 0,
    BranchId: 0,
    ClientId: 0,
    SiteId: 0,
    DepartmentId: 0,
    DesignationId: 0,
    Tagged: null,
    EnableLike: false,
    EnableComment: false,
    EnableKeepInEmployeesHistory: false,
    Duration: 1,
    Title: null as any,
    Description: null as any,
    Attachment: null as any,
    PostingTo: null as any
  }



  constructor(
    private post: FeedService,
    private employeeRegistration: EmployeeRegistrationService,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private utility: UtilityService
  ) {
    this.route.params.subscribe(params => this.FeedDetails.ESS_PostMasterID = parseInt(params['id']));
    this.user = this.session.GetUserDetails();
  }

  ngOnInit() {
    this.EmpMasterID = this.session.GetUserDetails().UserId;
    this.GetData();
    this.FeedLoad();
  }

  Postings = [{ postingLabel: 'Everyone' }, { postingLabel: 'Front' }, { postingLabel: 'Back' }]

  InsertUpdate() {
    this.isDisabled = true;
    this.post.InsertPost(this.FeedDetails).subscribe({
      next: (Response) => {
        if (Response.Error_Code == '01') {
          this.toast.show({ message: Response.Error_Message, type: toastTypeEnum.success });
          this.isDisabled = false;
          this.router.navigate(['/feed']);
        }
        else {
          this.toast.show({ message: Response.Error_Message, type: toastTypeEnum.danger });
          this.isDisabled = false;
        }

      },
      complete() {
      },
      error(err) {
      },
    })
  }


  FeedLoad() {
    if (this.FeedDetails.ESS_PostMasterID > 0) {
      this.post.PostLoad({ SelectType: 1, ESS_PostMasterID: this.FeedDetails.ESS_PostMasterID }).subscribe((response) => {
        if (response.Table.toString != null) {
          this.FeedDetails.Title = response.Table[0].Title;
          this.FeedDetails.Description = response.Table[0].Description;
          this.FeedDetails.EnableKeepInEmployeesHistory = response.Table[0].EnableKeepInEmployeesHistory;
          this.FeedDetails.EnableLike = response.Table[0].EnableLike;
          this.FeedDetails.EnableComment = response.Table[0].EnableComment;
          this.FeedDetails.PostingTo = response.Table[0].PostingTo;
          this.FeedDetails.SelectType = "Update";
        }

      },
        (err) => { }
      );
    }

  }

  GetData() {
    this.employeeRegistration.GetData({ 'SelectType': "View", 'EmpMasterId': this.EmpMasterID, 'IsDraft': "false" }).subscribe({
      next: (response) => {
        if (response.Table2.toString() != null) {
          this.FeedDetails.BranchId = response.Table2[0].BranchID;
          this.FeedDetails.DepartmentId = response.Table2[0].DepartmentId;
          this.FeedDetails.DesignationId = response.Table2[0].DesignationId;
          this.FeedDetails.ClientId = response.Table2[0].ClientId;
          this.FeedDetails.SiteId = response.Table2[0].SiteId;
        }

        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {

      },
    });
  }

  Validate(form: any) {
    if (form.valid) {

      this.InsertUpdate();

    }
    else {
      form.submitted = true;
    }
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.FeedDetails.Attachment = file.name;
    }
  }

  upload(event: any, Folder: any, Tag = '') {
    try {
      if ((event.currentTarget.accept).includes(event.target.files[0].type.split('/')[1])) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.UploadServices(Folder, reader.result, Tag, null, event.target.files[0].type.split('/')[1]);
          event.target.value = null;
        };
      } else {
        this.toast.show({ message: 'selected file not allow, allow file only ' + event.currentTarget.accept, type: toastTypeEnum.danger });
        event.target.value = null;
      }
    } catch (e) { }
  }

  UploadServices(Folder: string, Base64: any, Tag = '', index = null, type = '') {
    this.isDisabled = true;
    this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': Base64 }).subscribe((response: any) => {
      if (response.FileName != "") {
        this.fileName = response.FileName;
        this.FeedDetails.Attachment = response.FileName;
        this.fileUrl = response.Url;
      } else {
        this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.warning });
      }
      this.isDisabled = false;
    }, (error) => {
      this.isDisabled = false;
    });
  }

  removeFile() {
    this.fileName = '';
    this.FeedDetails.Attachment = '';
    this.fileUrl = '';
  }

  viewDocument(url: any){
    window.open(url, '_blank');
  }

}
